import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
import CampaignModel from 'donor-elf-web/models/campaign';
import AddSomethingModal from 'donor-elf-web/services/add-something-modal';
import { DashboardCampaignItem } from '.';

interface ComponentArgs {
  dashboardCampaignItem: DashboardCampaignItem;
  onChangePin: (args: DashboardCampaignChangePinArgs) => void;
}

export interface DashboardCampaignChangePinArgs {
  campaign: CampaignModel;
  pin?: boolean;
  unpin?: boolean;
  moveUp?: boolean;
  moveDown?: boolean;
}

export default class DashboardCampaignsCampaignComponent extends Component<ComponentArgs> {
  @service declare addSomethingModal: AddSomethingModal;
  @service declare router: RouterService;

  get item() {
    return this.args.dashboardCampaignItem;
  }

  get barChartGivenStyle() {
    let percent = this.dashboard?.givenPercent;
    if (percent) {
      return htmlSafe(`width: ${percent}%`);
    }
    return '';
  }

  get barChartExpectingStyle() {
    let percent = this.dashboard?.expectingPercent;
    if (percent) {
      return htmlSafe(`width: ${percent}%`);
    }
    return '';
  }

  get expanded() {
    return this.args.dashboardCampaignItem.expanded;
  }

  get campaign() {
    return this.args.dashboardCampaignItem.campaign;
  }

  get goal() {
    return this.args.dashboardCampaignItem.campaignGoal;
  }

  get hasGoalAmount() {
    return (this.goal?.goalAmount || 0) > 0;
  }

  get dashboard() {
    return this.goal?.campaignGoalDashboard;
  }

  toggleExpanded = () => {
    this.item.expanded = !this.item.expanded;
  };

  handleMoreDetailsClicked = () => {
    this.router.transitionTo('funds.fund.campaigns.campaign', this.campaign.id);
  };
}
